import Record from './Record'

export default class CompanyGroup extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {
			// Create record
			return new CompanyGroup({
				id: null,
				name: '',
			})
		} else {
			// Load
			let data = await Anvil.REST.get(`/company_group/${id}`)
			return new CompanyGroup(data)
		}
	}

	static async delete (id) {
		await Anvil.REST.delete(`/company_group/${id}`)
	}

	async commit () {
		if (this._data.id == null) {
			// Insert
			const res = await Anvil.REST.post(`/company_group`, this._data)
			this._data.id = res.insertId
		} else {
			// Update
			await Anvil.REST.put(`/company_group/${this._data.id}`, this._data)
		}
	}
}
